<template>
  <div class="display-flex height-percent-100">
    <div class="width-260 padding-20 bc-white">
      <div class="display-flex  jc-space-between mb-20">
        <b class="fs-18">检查标准分类项目</b>
        <el-button @click="addDirectory" type="text" class="padding-0"> <i class="el-icon-plus"></i>添加分类</el-button>
      </div>
      <el-input
          placeholder="关键词查询"
          clearable
          v-model="filterText">
      </el-input>
      <el-scrollbar style="height: calc(100% - 60px); overflow-y: auto;">
        <el-tree
        ref="tree"
        node-key="id"
        highlight-current
        default-expand-all
        :expand-on-click-node="false"
        :data="directoryTree"
        :props="defaultProps"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-button
            type="text"
            class="el-icon-edit-outline color-primary"
            @click.stop="() => editDirectory(data)">
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button
            type="text"
            class="el-icon-delete color-danger"
            @click.stop="() => delDirectory(data)">
          </el-button>
        </span>
      </span>
      </el-tree>
      </el-scrollbar>
    </div>
    <div class="ml-20 bc-white flex-1" style="overflow: auto">
      <div style="line-height: 57px">
        <b class="ml-20 mr-16">检查标准列表</b>
        <span>已选分类: {{selTreeItem.name || '全部' }}</span>
      </div>
      <el-divider ></el-divider>
      <div class="padding-20">
        <div class="display-flex ai-center jc-space-between">
          <div>
            <el-input  v-model="searchForm.fuzzy" size="small" class="width-220 mr-20" placeholder="请输入关键词搜索" clearable ></el-input>
            <el-button  size="small" type="primary" @click="searchData">查询</el-button>
            <el-button size="small" @click="resetData">重置</el-button>
          </div>
          <el-button @click="addCheckItem" class="ml-12" size="small" type="primary"><i class="el-icon-plus"></i>检查标准</el-button>
        </div>
            <el-table
            size="small"
            class="mt-20"
            height="600px"
            v-el-table-infinite-scroll="getTableData"
            :infinite-scroll-disabled="noMore"
            border
            :data="tableData">
            <el-table-column
              width="247"
              label="所属分类">
              <template #default="{row}">
                {{ row.checkStandardNameList.join('>')}}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="检查标准(合规要求)">
              <template #default="{row}">
                <div v-html="replaceWhite(row.content)"></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="basisName"
              label="检查依据">
              <template #default="{row}">
                <b>依据文件名称</b>
                <div>{{ row.basisName }}</div>
                <b>依据文件编号</b>
                <div>{{ row.basisNo }}</div>
                <b>依据条目号及其原文</b>
                <div>{{ row.basisContent }}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              width="94"
              prop="yhSize"
              label="潜在隐患">
              <template #default="{row}">
                <el-button size="mini" type="text" @click="showHiddenRisk(row)">{{ row.yhSize}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="114"
              prop="email"
              label="操作">
              <template #default="{row}">
                <el-button size="mini" type="text" @click="editCheckItem(row)">编辑</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button size="mini" type="text" class="color-danger" @click="delCheckItem(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        <div class="display-flex fd-row-reverse mt-20">
          <el-pagination
            hide-on-single-page
            @current-change="(val) => {searchForm.pageNum = val}"
            :current-page="searchForm.pageNum"
            :page-size="searchForm.pageSize"
            background
            layout="total, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="directoryDialog.show"
      :title="directoryDialog.title"
      :visible.sync="directoryDialog.show"
      width="490px">
      <el-form class="diy-top-form" :model="directoryDialog.form" ref="directoryForm" label-position="top" size="small">
        <el-form-item label="分类名称" prop="name" :rules="{required: true, message: '请输入分类名称', trigger: 'blur'}">
          <el-input v-model="directoryDialog.form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="parentId">
          <el-cascader
            placeholder="请选择上级分类"
            class="width-percent-100"
            v-model="directoryDialog.form.parentId"
            :options="directoryTree"
            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true, label: 'name', value: 'id' }"></el-cascader>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number class="width-percent-100" v-model="directoryDialog.form.sort" placeholder=""></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" type="primary" @click="submitDirectory">确 定</el-button>
        <el-button size="small" @click="directoryDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="checkItemDialog.show"
      :title="checkItemDialog.title"
      :visible.sync="checkItemDialog.show"
      width="656px">
      <el-form class="diy-top-form" :model="checkItemDialog.form" ref="positionForm" label-position="top" size="small" :rules="rules">
        <div class="display-flex ai-center" style="line-height: 40px;">
          <b style="font-size: 16px; font-weight: bolder">基本信息</b>
        </div>
        <el-form-item label="所属分类" prop="checkStandardId" :rules="{required: true, message: '请选择所属分类（单选),选到任意一级', trigger: 'blur'}">
          <el-cascader
            clearable
            placeholder="请选择所属分类（单选），选到任意一级"
            class="width-percent-100"
            v-model="checkItemDialog.form.checkStandardId"
            :options="directoryTree"
            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true, label: 'name', value: 'id' }"></el-cascader>
        </el-form-item>
        <el-form-item label="检查标准 (合规要求)" prop="content" >
          <!-- <el-input type="textarea" v-model="checkItemDialog.form.content" placeholder="请输入检查标准 (合规要求)"></el-input> -->
          <wang-editor class="mt-10" ref="editor" :default-html="checkItemDialog.form.content"></wang-editor>
        </el-form-item>
        <div class="display-flex ai-center" style="line-height: 40px;">
          <b style="font-size: 16px; font-weight: bolder">检查依据</b>
        </div>
        <el-form-item label="依据文件名称">
          <el-input v-model="checkItemDialog.form.basisName" placeholder="请输入依据文件名称"></el-input>
        </el-form-item>
        <el-form-item label="依据文件编号">
          <el-input v-model="checkItemDialog.form.basisNo" placeholder="请输入依据文件编号"></el-input>
        </el-form-item>
        <el-form-item label="依据条目号及原文">
          <el-input v-model="checkItemDialog.form.basisContent" placeholder="依据条目号及原文"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" type="primary" @click="submitCheckItem">确 定</el-button>
        <el-button size="small" @click="checkItemDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="hiddenRiskDialog.show"
      :title="hiddenRiskDialog.title"
      :visible.sync="hiddenRiskDialog.show"
      width="1120px">
      <el-form class="diy-top-form" label-width="180px" :model="hiddenRiskDialog.form" ref="hiddenRiskForm" label-position="right" size="small">
        <!-- <div class="risk-info">
          <el-form-item label="合规要求" prop="content">
             <span>{{  hiddenRiskDialog.form.content}}</span>
          </el-form-item>
          <el-form-item label="依据文件名称">
            <span>{{  hiddenRiskDialog.form.basisName }}</span>
          </el-form-item>
          <el-form-item label="依据文件编号">
            <span>{{  hiddenRiskDialog.form.basisNo }}</span>
          </el-form-item>
          <el-form-item label="依据条目号及原文">
            <span>{{  hiddenRiskDialog.form.basisContent }}</span>
          </el-form-item>
        </div> -->
        <div class="risk-content">
          <div class="display-flex jc-space-between ai-center" style="line-height: 56px;">
             <span style="font-weight: bold;">潜在隐患列表</span>
             <el-button type="text" class="el-icon-plus" @click="addRisk">添加潜在隐患</el-button>
          </div>
          <el-table
          size="small"
          border
          :data="hiddenRiskDialog.form.riskList">
          <el-table-column
            align="center"
            prop="content"
            label="潜在隐患内容">
          </el-table-column>
          <el-table-column
            align="center"
            width="114"
            prop="yhLevel"
            label="隐患级别">
            <template #default="{row}">
               {{ row.yhLevel|sortLevel }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="suggestion"
            label="建议整改措施">
          </el-table-column>
          <el-table-column
            width="115"
            align="center"
            prop="updateByName"
            label="最后修改人">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateAt"
            label="最后修改时间">
          </el-table-column>
          <el-table-column
            width="114"
            align="center"
            prop="email"
            label="操作">
            <template #default="{row}">
              <el-button size="mini" type="text" @click="editRiskItem(row)">编辑</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button size="mini" type="text" class="color-danger" @click="delRiskItem(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="display-flex fd-row-reverse mt-20">
          <el-pagination
            hide-on-single-page
            @current-change="(val) => {riskSearchForm.pageNum = val}"
            :current-page="riskSearchForm.pageNum"
            :page-size="riskSearchForm.pageSize"
            background
            layout="total, prev, pager, next, jumper"
            :total="riskTotal">
          </el-pagination>
        </div>
        </div>
      </el-form>
      <el-dialog
        :title="riskDialog.title"
        :visible.sync="riskDialog.show"
        width="490px"
        append-to-body>
        <!-- <div class="risk-info">
          <el-form class="diy-top-form" label-width="120px" ref="hiddenRiskForm" label-position="right" size="small">
            <el-form-item label="合规要求" prop="content">
               <span>{{  riskDialog.form.riskContent}}</span>
            </el-form-item>
          </el-form>
        </div> -->
        <el-form class="diy-top-form" label-width="180px" :model="riskDialog.form" ref="riskForm" label-position="top" size="small">
           <el-form-item label="潜在隐患内容" :rules="{required: true, message: '请输入潜在隐患内容', trigger: 'blur'}">
             <el-input type="textarea" v-model="riskDialog.form.content" placeholder="请输入潜在隐患内容"></el-input>
           </el-form-item>
           <el-form-item label="隐患级别" :rules="{required: true, message: '请选择隐患级别', trigger: 'blur'}">
            <el-radio-group v-model="riskDialog.form.yhLevel">
                <el-radio :label="1">一般隐患</el-radio>
                <el-radio :label="2">重大隐患</el-radio>
              </el-radio-group>
           </el-form-item>
           <el-form-item label="建议整改措施" >
             <el-input type="textarea" v-model="riskDialog.form.suggestion" placeholder="请输入建议整改措施"></el-input>
           </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" type="primary" @click="submitRisk">确 定</el-button>
          <el-button size="small" @click="riskDialog.show = false">取 消</el-button>
        </span>
      </el-dialog>
      <span slot="footer">
        <el-button size="small" type="primary" @click="submitHiddenRisk">确 定</el-button>
        <el-button size="small" @click="hiddenRiskDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import _ from 'lodash';
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
import WangEditor from '../../../components/WangEditor.vue';
export default {
  name: 'CheckStandard',
  components: { WangEditor },
  props: {},
  data () {
    var validatePass = (rule, value, callback) => {
      if (this.$refs.editor.editor.getHtml().includes('img') || !!this.$refs.editor.editor.getText().trim()) {
        callback()
      } else {
        callback(new Error('请输入检查标准 (合规要求)'))
      }
    }
    return {
      noMore: false,
      rules: {
        content: [
          { validator: validatePass, trigger: 'change', required: true }
        ]
      },
      searchForm: {
        fuzzy: '',
        checkStandardId: '',
        pageNum: 1,
        pageSize: 10,
        total: 10
      },
      riskSearchForm: {
        pageNum: 1,
        pageSize: 5
      },
      total: 0,
      riskTotal: 0,
      directoryTree: [], // 目录树
      selTreeItem: {
        name: '',
        id: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      directoryDialog: { // 目录dialog
        show: false,
        title: '',
        form: {
          id: '',
          name: '',
          parentId: '',
          sort: 1
        }
      },
      checkItemDialog: { // 标准列表dialog
        show: false,
        title: '',
        form: {
          id: '',
          checkStandardId: '',
          content: '',
          basisName: '',
          basisNo: '',
          basisContent: '',
          basisSrc: 2
        }
      },
      hiddenRiskDialog: {
        show: false,
        title: '',
        form: {
          id: '',
          content: '',
          basisName: '',
          basisNo: '',
          basisContent: ''
        }
      },
      riskDialog: {
        title: '',
        show: false,
        form: {
          id: '',
          riskContent: '',
          content: '',
          yhLevel: '',
          suggestion: ''
        }
      },
      tableData: [],
      filterText: ''
    }
  },
  directives: {
    'el-table-infinite-scroll': ElTableInfiniteScroll
  },
  filters: {
    sortLevel (val) {
      return val === 1 ? '一般隐患' : '重大隐患'
    }
  },
  computed: {},
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
    selTreeItem: {
      handler (newVal, oldVal) {
        this.searchForm.checkStandardId = newVal.id || '';
        this.searchForm.pageNum = 1;
        this.getTableData();
      },
      deep: true,
      immediate: true
    },
    riskSearchForm: {
      handler (newVal, oldVal) {
        this.getRiskeData()
      },
      deep: true
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    replaceWhite (html) { // 处理富文本默认图片，视频大小
      let newContent = html.replace(/<video[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      }).replace(/<img[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      });
      newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
          'max-width:100%;')
        return match
      });
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      newContent = newContent.replace(/<video/gi,
        '<video style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"').replace(/<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"')
      return newContent
    },
    searchData () {
      this.searchForm.pageNum = 1;
      this.tableData = [];
      this.getTableData()
    },
    resetData () {
      this.searchForm.pageNum = 1;
      this.searchForm.fuzzy = '';
      this.tableData = [];
      this.getTableData()
    },
    // 点击树节点(改一下逻辑, 监听selTreeItem的变化, 动态更新getTableData)
    handleNodeClick (e) {
      if (!this.selTreeItem.id) {
        this.selTreeItem = e;
      } else {
        if (this.selTreeItem.id !== e.id) {
          this.selTreeItem = e;
        } else {
          this.selTreeItem = {
            name: '',
            id: ''
          }
          this.$refs.tree.setCurrentKey(null);
        }
      }
    },
    // children中为[]时转换成undefined （解决el-cascader中无子节点也打开下一层级）
    circulate (data) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].children.length) {
          data[i].children = undefined;
        } else {
          this.circulate(data[i].children)
        }
      }
      return data
    },
    // 树结构数据
    getDirectoryTree () {
      return new Promise((resolve, reject) => {
        this.$api.checkStandard.getTreeData().then(res => {
          this.directoryTree = this.circulate(res);
          if (this.selTreeItem.id) {
            this.$nextTick(() => {
              // this.$refs.tree.setCurrentKey(null);
              this.$refs.tree.setCurrentKey(this.selTreeItem.id);
              // 更新当前选中项的相关参数
              this.selTreeItem = this.$refs.tree.getCurrentNode()
            })
          }
          resolve(res)
        })
      })
    },
    // 某个目录下的列表
    getTableData: _.debounce(function () {
      if (this.searchForm.pageNum === 1) {
        this.noMore = false
        this.$api.checkStandard.getTableData(this.searchForm).then(res => {
          this.tableData = res.list || [];
          this.searchForm.total = res.list?.length || 0;
          this.searchForm.pageNum += 1;
          if (this.searchForm.total < this.searchForm.pageSize) {
            this.noMore = true
          }
        })
      } else {
        if (this.noMore) return;
        this.$api.checkStandard.getTableData(this.searchForm).then(res => {
          this.tableData.push(...res.list)
          this.searchForm.total = res.list?.length || 0;
          this.searchForm.pageNum += 1;
          if (this.searchForm.total < this.searchForm.pageSize) {
            this.noMore = true
          }
        })
      }
    }, 500),
    // 某个目录下的列表
    getRiskeData: _.debounce(function () {
      this.$api.checkStandard.getyhList(this.riskSearchForm).then(res => {
        this.hiddenRiskDialog.form.riskList = res.list
        this.riskTotal = res.total
      });
    }, 500),
    addRisk () {
      this.riskDialog = {
        title: '添加潜在隐患',
        show: true,
        form: {
          id: '',
          riskContent: this.hiddenRiskDialog.form.content,
          content: '',
          yhLevel: '',
          suggestion: ''
        }
      }
    },
    editRiskItem (row) {
      this.riskDialog = {
        title: '编辑潜在隐患',
        show: true,
        form: {
          id: row.id,
          riskContent: this.hiddenRiskDialog.form.content,
          content: row.content,
          yhLevel: row.yhLevel,
          suggestion: row.suggestion
        }
      }
    },
    delRiskItem (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkStandard.delyh({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.getRiskeData();
        })
      }).catch(() => {});
    },
    addDirectory () {
      this.directoryDialog = {
        show: true,
        title: '添加分类',
        form: {
          id: '',
          name: '',
          parentId: '',
          sort: 1
        }
      }
    },
    editDirectory (data) {
      this.directoryDialog = {
        show: true,
        title: '编辑分类',
        form: {
          id: data.id,
          name: data.name,
          parentId: data.parentId,
          sort: data.sort
        }
      }
    },
    delDirectory (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkStandard.delTreeItem({ id: data.id }).then(res => {
          this.$message.success('删除成功')
          this.getDirectoryTree();
          this.selTreeItem = {
            name: '',
            id: ''
          }
        })
      }).catch(() => {});
    },
    addCheckItem () {
      this.checkItemDialog = {
        show: true,
        title: '添加检查项目',
        form: {
          id: '',
          content: '',
          checkStandardId: this.selTreeItem.id,
          basisNo: '',
          basisName: '',
          basisContent: '',
          basisSrc: 2
        }
      }
    },
    editCheckItem (data) {
      console.log(data.content);
      this.checkItemDialog = {
        show: true,
        title: '编辑检查项目',
        form: {
          id: data.id,
          content: data.content,
          checkStandardId: data.checkStandardId,
          basisNo: data.basisNo,
          basisName: data.basisName,
          basisContent: data.basisContent,
          basisSrc: 2
        }
      }
    },
    delCheckItem (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.checkStandard.delCheckItem({ id: data.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.pageNum = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    showHiddenRisk (row) {
      this.$api.checkStandard.getyhList({
        checkStandardItemId: row.id,
        pageNum: this.riskSearchForm.pageNum,
        pageSize: this.riskSearchForm.pageSize
      }).then(res => {
        this.riskSearchForm.checkStandardItemId = row.id
        this.riskTotal = res.total
        this.hiddenRiskDialog = {
          show: true,
          title: '潜在隐患',
          form: {
            id: row.id, // 潜在隐患列表中的id
            content: row.content,
            basisName: row.basisName,
            basisNo: row.basisNo,
            basisContent: row.basisContent,
            riskList: res.list || []
          }
        }
      })
    },
    submitRisk () {
      this.$refs.riskForm.validate(valid => {
        if (valid) {
          if (this.riskDialog.form.id) {
            this.$api.checkStandard.updateyh({
              checkStandardItemId: this.riskSearchForm.checkStandardItemId,
              ...this.riskDialog.form
            }).then(res => {
              this.$message.success('编辑成功')
              this.riskDialog.show = false
              this.getRiskeData();
              // this.getDirectoryTree() 更改为获取隐患列表
            })
          } else {
            this.$api.checkStandard.addyh({
              checkStandardItemId: this.riskSearchForm.checkStandardItemId,
              ...this.riskDialog.form
            }).then(res => {
              this.$message.success('添加成功')
              this.riskDialog.show = false;
              this.getRiskeData();
              // 获取隐患列表
            })
          }
        }
      })
    },
    submitHiddenRisk () {
      this.hiddenRiskDialog.show = false;
      this.getTableData();
    },
    // 提交目录新增和编辑
    submitDirectory () {
      this.$refs.directoryForm.validate(valid => {
        if (valid) {
          if (this.directoryDialog.form.id) {
            this.$api.checkStandard.updateTreeItem(this.directoryDialog.form).then(res => {
              this.$message.success('编辑成功')
              this.directoryDialog.show = false
              this.getDirectoryTree()
            })
          } else {
            this.directoryDialog.form.parentId = this.directoryDialog.form.parentId || null;
            this.$api.checkStandard.addTreeItem(this.directoryDialog.form).then(res => {
              this.$message.success('添加成功')
              this.directoryDialog.show = false
              this.getDirectoryTree();
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.selTreeItem.id)
              })
              // this.getDirectoryTree()
            })
          }
        }
      })
    },
    // 提交检查标准
    submitCheckItem () {
      this.$refs.positionForm.validate(valid => {
        if (valid) {
          const data = {
            ...this.checkItemDialog.form,
            content: this.$refs.editor.editor.getHtml()
          }
          if (this.checkItemDialog.form.id) {
            this.$api.checkStandard.updateCheckItem(data).then(res => {
              this.$message.success('编辑成功')
              this.checkItemDialog.show = false;
              this.searchForm.pageNum = 1;
              this.getTableData()
            })
          } else {
            this.$api.checkStandard.addCheckItem(data).then(res => {
              this.$message.success('添加成功')
              this.checkItemDialog.show = false;
              this.searchForm.pageNum = 1;
              this.getTableData()
            })
          }
        }
      })
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.getDirectoryTree()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.diy-top-form {
  overflow: hidden;
  b::before {
    content: '';
    width: 4px;
    height: 16px;
    background: #2A5EFF;
    display: inline-block;
    margin-right: 10px;
    margin-top: 4px;
  }
}

.risk-info {
  border: 3px dashed #C9C9C9;
  background-color: #F8F8F8;
  span {
    margin-left: 38px;
  }
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
 ::v-deep .el-tree-node__content {
    height: 36px;
    border: 1px solid #fff;
  }
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #E9EFFF;
  border-radius: 4px;
  border: 1px solid #8AA6FB;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
    background-color: #fff;
}
</style>
